import {ImageAlignEnum} from '@doltech/ui/lib/figma/DolEditor/components/ImageResizableAlignable/ImageAlignEnum';
import {SnapshotIn, types as t} from 'mobx-state-tree';

import {ImageInfo} from '../../Script/abtract-script.store';
import {Spot} from '../abstract-question-with-spots.store';
import {BlankUserAnswer} from '../Blank/blank-user-answer.store';
import {BlankCorrectAnswer} from '../CorrectOption/_extends/blank-correct-answer.store';

const VoidBlank = t.model('VoidBlank', {
  blankId: t.identifier,
  blankIndex: t.optional(t.number, 0),
  range: t.array(t.number),
});

export interface VoidBlankSnapshotIn extends SnapshotIn<typeof VoidBlank> {}

t.model('PositionOptions', {
  x: t.optional(t.number, 0),
  y: t.optional(t.number, 0),
});

const InputBlankResizable = t
  .model('InputBlankResizable', {
    blanks: t.array(VoidBlank),
    editorValue: t.string,
  })
  .views((self) => ({
    getEditorValue() {
      return JSON.parse(self.editorValue);
    },
  }));

const PrivateImageObj = ImageInfo.named('PrivateImageObj');

const ImageResizable = t.model('ImageResizable', {
  width: t.optional(t.number, 0),
  image: t.maybeNull(PrivateImageObj),
  align: t.maybeNull(t.optional<any>(t.string, ImageAlignEnum.ALIGN_LEFT)),
  spots: t.array(Spot),
});

export const DiagramLabelCompletion = t
  .model('DiagramLabelCompletion', {
    nodeImage: t.optional(ImageResizable, {}),
    nodeBlanks: t.array(InputBlankResizable),
    correctAnswers: t.array(BlankCorrectAnswer),
    userAnswers: t.array(t.maybeNull(BlankUserAnswer)),
  })
  .views((self) => ({
    getBlanksFromNodeBlanks(): VoidBlankSnapshotIn[] {
      const arrBlanks = [];
      self.nodeBlanks.forEach((nodeBlank) => {
        nodeBlank.blanks.forEach((blank) => {
          arrBlanks.push(blank);
        });
      });

      return arrBlanks;
    },
  }));
